import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import { useSearch } from "../../../hooks/seach/useSearch";
import { styles } from "./styles";

export default function Controlador() {
    const {
        controlador, setControlador,
        listControladores
    } = useSearch();

    return (
        <>
            <Typography style={styles.labelInput}>
                Controlador Responsável:
            </Typography>

            <FormControl variant="outlined" style={styles.formControl}>
                <Select
                    onChange={e => setControlador(e.target.value)}
                    value={controlador}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    {listControladores.filter(res => res.name !== 'Todos').map((res, idx) => (
                        <MenuItem value={res.name} key={idx}>
                            {res.name}
                        </MenuItem>)
                    )}
                </Select>
            </FormControl>
        </>
    );
}
